import { IState } from '../../store';

export const selectSelectedUserType = (state: IState) => state.requestDemand.selectedUserType;
